import "./index.less";
import Pagination from "rc-pagination";
import { useNewsListCtrl, useNewsListHook } from "../hooks/useNewsList";
import { logPageAccess } from "@/utils/logPageAccess";
import { scrollToTop } from "@/utils/scrollToTop";

export default function Paging() {
  const [current, setCurrent] = useState(1);
  const { scrollNewsListY, total, queryParams, setNewsList } = useNewsListCtrl();
  const { loadNewsList } = useNewsListHook();
  const { pathname } = useLocation();
  const onChange = (page: number) => {
    logPageAccess(pathname, isDevEnv);
    setCurrent(page);
    setNewsList(prev => ({
      ...prev,
      loadingNewsList: true,
      queryParams: {
        ...queryParams,
        page: page,
      },
    }));
  };
  useEffect(() => {
    const page = queryParams.page <= 0 ? 1 : queryParams.page;
    setNewsList(prev => ({
      ...prev,
      loadingNewsList: true,
      queryParams: {
        ...queryParams,
        page: page,
      },
    }));
    setCurrent(page);
  }, []);
  useEffect(() => {
    if (queryParams.page <= 0) {
      return;
    }
    scrollToTop(Number(scrollNewsListY));
    loadNewsList();
  }, [queryParams.page]);
  useListenScroll();
  return (
    <div className="color-[var(--app-text-06)] font-400 text-14 px-16 h-32 mb-10 center">
      <Pagination onChange={onChange} current={current} total={total} pageSize={10} />
    </div>
  );
}
